import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, Paper, Grid } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import styles from "./ScriptRunnerV2.module.css";
import ExecutionTable from "./components/ExecutionTable";
import useScriptPermissions from "./hooks/useScriptPermissions";

// interns scriptrunner - ScriptRunnerV2 component for the new admin dashboard
const ScriptRunnerV2 = () => {
  const navigate = useNavigate();
  const { canWrite } = useScriptPermissions();

  return (
    <div className={styles.container}>
      {/* interns scriptrunner - back button to navigate to home or previous page */}
      <div className={styles.headerRow}>
        <Button
          className={styles.backButton}
          onClick={() => navigate("/home")}
          startIcon={<ArrowBackIcon />}
        >
          Back to Home
        </Button>
      </div>

      <Paper className={styles.dashboardPaper} elevation={3}>
        <Box className={styles.dashboardContainer}>
          {/* Header */}
          <Box className={styles.headerSection}>
            <Typography variant="h4" className={styles.heading}>
              Script Runner (Interns 2026)
            </Typography>

            <Typography variant="subtitle1" className={styles.subheading}>
              Admin Dashboard for managing and uploading scripts
            </Typography>
          </Box>

          {/* Cards */}
          <Grid
            container
            spacing={4}
            justifyContent="center"
            alignItems="stretch"
            className={styles.cardsContainer}
          >
            {/* View Scripts */}
            <Grid item xs={12} sm={6} md={4} className={styles.cardGridItem}>
              <Paper
                className={styles.actionCard}
                onClick={() => navigate("/script-runner-V2/view")}
                elevation={0}
              >
                <ListAltIcon className={styles.actionIcon} />

                <Typography variant="h6" className={styles.actionTitle}>
                  View Scripts
                </Typography>

                <Typography className={styles.actionDescription}>
                  Browse and manage all existing scripts
                </Typography>

                <Button
                  className={styles.primaryButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate("/script-runner-V2/view");
                  }}
                >
                  View Scripts
                </Button>
              </Paper>
            </Grid>

            {/* Upload Scripts */}
            {canWrite && (
              <Grid item xs={12} sm={6} md={4} className={styles.cardGridItem}>
                <Paper
                  className={styles.actionCard}
                  onClick={() => navigate("/script-runner-V2/upload")}
                  elevation={0}
                >
                  <CloudUploadIcon className={styles.actionIcon} />

                  <Typography variant="h6" className={styles.actionTitle}>
                    Upload Scripts
                  </Typography>

                  <Typography className={styles.actionDescription}>
                    Add new scripts to the runner
                  </Typography>

                  <Button
                    className={styles.primaryButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/script-runner-V2/upload");
                    }}
                  >
                    Upload Scripts
                  </Button>
                </Paper>
              </Grid>
            )}
          </Grid>
        </Box>
      </Paper>

      {/* interns scriptrunner - Added execution history table below buttons */}
      <ExecutionTable />
    </div>
  );
};

export default ScriptRunnerV2;
